import { render, staticRenderFns } from "./ExternalLinkCoupon.vue?vue&type=template&id=42b657e3&scoped=true&"
import script from "./ExternalLinkCoupon.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLinkCoupon.vue?vue&type=style&index=0&id=42b657e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b657e3",
  null
  
)

export default component.exports